import { render } from "./upload_images.vue?vue&type=template&id=907637e2&scoped=true"
import script from "./upload_images.vue?vue&type=script&lang=js"
export * from "./upload_images.vue?vue&type=script&lang=js"

import "./upload_images.vue?vue&type=style&index=0&id=907637e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907637e2"]])

export default __exports__